import type { MapRef } from 'react-map-gl/mapbox';
import { updateAdminFilters, updateLocationResult } from '@alltrails/explore-service/redux/exploreServiceSlice';
import type ExploreEventData from '@alltrails/explore-service/types/ExploreEventData';
import flyToPoint from '@alltrails/maps/utils/flyToPoint';
import type { StreetAddressResult } from '@alltrails/types/AlgoliaResults';
import { AppDispatch } from '@/utils/redux';
import { setStreetAddressLngLat } from '@/utils/slices/exploreSlice';

export const handleStreetAddressResultSelect = (result: StreetAddressResult, dispatch: AppDispatch, map?: MapRef) => {
  if (map && result) {
    const lngLat: [number, number] = [result.geo.longitude, result.geo.latitude];
    dispatch(setStreetAddressLngLat(lngLat));
    dispatch(updateLocationResult(result));
    dispatch(updateAdminFilters({}));
    const eventData: ExploreEventData = { preserveLocationResult: true };
    flyToPoint(map, lngLat, eventData);
  }
};
